import { jsx as e, jsxs as M, Fragment as N } from "react/jsx-runtime";
import { CellAdditionalInfoWrapper as T } from "./index.es731.js";
import U from "classnames";
import { useMemo as o } from "react";
import { getNumericFormat as y } from "./index.es732.js";
import i from "./index.es733.js";
import { BodyText as a } from "./index.es505.js";
import { Icon as j } from "./index.es157.js";
const q = ({
  label: s,
  parenthesisValue: n,
  testId: t = "parenthesis-cell",
  type: r = "positive",
  addArrowIndication: D,
  textAlign: l = "right",
  formatValue: I,
  labelFormat: S,
  parenthesisFormat: b,
  additionalInfo: A
}) => {
  const {
    type: m = "default",
    shorten: c = !0,
    maxDecimal: p,
    signIndicator: d
  } = S ?? {}, {
    type: h = "default",
    shorten: u = !0,
    maxDecimal: f,
    signIndicator: g = !0
  } = b ?? {}, x = o(() => y({
    value: s,
    maxDecimal: p,
    shorten: c,
    type: m,
    signIndicator: d
  }), [
    s,
    m,
    p,
    c,
    d
  ]), F = o(() => y({
    value: n,
    maxDecimal: f,
    shorten: u,
    type: h,
    signIndicator: g
  }), [
    n,
    f,
    u,
    h,
    g
  ]), v = o(
    () => r === "positive" ? "success" : r === "negative" ? "error" : "gray",
    [r]
  ), C = r !== "neutral" && D, w = r === "positive", E = U(i.parenthesisCellRoot, {
    [i.alignLeft]: l === "left",
    [i.alignCenter]: l === "center"
  });
  return /* @__PURE__ */ e("div", { className: E, children: /* @__PURE__ */ e(T, { ...A, children: x ? /* @__PURE__ */ M(N, { children: [
    /* @__PURE__ */ e(a, { color: "primary", element: "p", isEllipsis: !0, "data-testid": t, children: x }),
    !!F && /* @__PURE__ */ e(
      a,
      {
        color: v,
        element: "p",
        isEllipsis: !0,
        "data-testid": t + "-parenthesis-value",
        children: ` (${F})`
      }
    ),
    C && /* @__PURE__ */ e(
      j,
      {
        type: w ? "ArrowUp" : "ArrowDown",
        size: 16,
        color: v,
        weight: "outline",
        testId: `icon-${w ? "ArrowUp" : "ArrowDown"}`
      }
    )
  ] }) : /* @__PURE__ */ e(a, { variant: "semi-bold", testId: t, isEllipsis: !0, children: I }) }) });
};
export {
  q as ParenthesisCell
};
//# sourceMappingURL=index.es558.js.map
